<div *ngIf="task" ngModelGroup="task"
  class="mct-gap-27 mct-grid task-edit-grid">
  <div class="area-header">
    <div
      class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center mct-gap-10-lt-md">
      <div *ngIf="allowProfileAssignment">
        <div class="mct-flex mct-row" *ngIf="profile; else noProfile">
          <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd"
            [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }" [profileId]="profile.ProfileId"
            [memberTypeIconColor]="profile.MemberTypeIconColor"></wl-profile-type-icon>
          <h4>
            {{ profile.ReportName }} <span class="light-text">({{ profile.ProfileId }})</span>
          </h4>
        </div>
      </div>
      <ng-template #noProfile>
        <div *ngIf="task.ProfileID; else unlinkedTask">
          <wl-busy [show]="true"></wl-busy>
        </div>
        <ng-template #unlinkedTask>
          <span class="light-text">{{ 'tasks.edit.this-task-is-not-linked-to-profile' | translate | ucfirst }}</span>
        </ng-template>
      </ng-template>
      <div class="w-40 w-100-lt-md flex row-collapse content-end">
        <div>
          <label for="assignedTo">{{ 'tasks.edit.assigned-to' | translate | ucfirst }}</label>
          <p-select required id="assignedTo" name="assignedTo" appendTo="body" #assignedTo="ngModel"
            placeholder="{{ 'tasks.edit.assign-this-task' | translate }}" [(ngModel)]="task.UserNum"
            [options]="userSelectItems" [style]="{ 'margin-left': '5px', height: '36px' }" showClear
            (onChange)="assignmentChanged()"></p-select>
        </div>
      </div>
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-justify-start-lt-md mct-items-center-lt-md">
      <span [hidden]="task.UserNum == 0 || task.UserNum == currentUser.UserNum || !assignedTo.dirty"
        class="assign-to-note">{{
        'tasks.edit.assignee-will-receive-notification-email' | translate | ucfirst
        }}</span>
    </div>
  </div>

  <div class="area-left">
    <div class="mb-27 mct-flex mct-col">
      <label>{{ 'tasks.edit.task-description' | translate | ucfirst }}</label>
      <input required name="description" placeholder="{{ 'tasks.edit.what-is-this-task' | translate | ucfirst }}"
        [(ngModel)]="task.Descr" />
    </div>
    <div>
      <label>{{ 'tasks.edit.task-type' | translate | ucfirst }}</label>
      <p-select name="taskType" required appendTo="body" placeholder="{{ 'tasks.edit.select-a-task-type' | translate }}"
        [(ngModel)]="task.TaskType" [options]="taskTypeItems" [style]="{ width: '100%', height: '36px' }"
        showClear></p-select>
    </div>
  </div>

  <div class="area-right">
    <div class="mb-27">
      <label>{{ 'tasks.edit.assigned-by' | translate | ucfirst }}</label>
      <p-select required name="assignedBy" appendTo="body" placeholder="{{ 'tasks.edit.select' | translate }}"
        [(ngModel)]="task.AssignedBy" [options]="userSelectItems" [style]="{ width: '100%', height: '36px' }" showClear
        (onChange)="assignmentChanged()"></p-select>
    </div>
    <div class="mct-flex mct-row mct-flex-lt-lg mct-col-lt-lg mct-gap-10">
      <div>
        <label>{{ 'tasks.edit.due-date' | translate | ucfirst }}</label>
        <wl-date-selector [required]="true" name="dueDate" [(ngModel)]="task.DateDue"
          appendTo="body"></wl-date-selector>
      </div>
      <div>
        <p-checkbox class="mb-5" name="completed" binary="true" [(ngModel)]="task.Closed"
          (onChange)="completedChanged()"></p-checkbox>
        <label class="mb-5">
          <span class="f-wb">{{ 'tasks.edit.completed' | translate | uppercase }}</span>
          &nbsp;
          <span>{{ 'tasks.edit.on' | translate }}</span>
        </label>
        <wl-date-selector name="completedOn" [(ngModel)]="task.DateClosed" appendTo="body"
          [disabled]="!task.Closed"></wl-date-selector>
      </div>
    </div>
  </div>

  <div class="area-bottom">
    <div class="mct-flex mct-col mct-gap-10 mb-27">
      <label>{{ 'tasks.edit.notify-when-complete' | translate | ucfirst }}</label>
      <input type="text" name="NotifyWhenComplete" [(ngModel)]="task.NotifyWhenComplete" />
    </div>

    <div class="mct-flex mct-col mct-gap-10">
      <label>{{ 'tasks.edit.notes' | translate | ucfirst }}</label>
      <textarea pInputTextarea name="notes" [(ngModel)]="task.Notes"></textarea>
    </div>
  </div>
</div>
